// Simple Contact Email Service
// Uses the same Brevo API as the contact form to send emails to contact@codealignr.com

export interface ContactInfo {
  name: string;
  email: string;
  phone?: string;
  message?: string;
  interest?: string;
  companyName?: string;
  preferredContactTime?: string;
}

// Send contact info through the Vercel serverless endpoint so the Brevo API key stays server-side
export const sendContactEmail = async (data: ContactInfo): Promise<{ success: boolean; messageId?: string }> => {
  console.log('📧 sendContactEmail called with data:', data);

  try {
    const base = process.env.REACT_APP_API_BASE_URL || '';
    const url = `${base}/api/send-contact-email`;
    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error('❌ API error response:', errorText);
      throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
    }

    const result = await response.json();
    console.log('✅ Email sent successfully via serverless API:', result);
    return { success: true, messageId: result.messageId };
  } catch (error) {
    console.error('❌ Error sending contact email:', error);
    if (error instanceof Error) {
      console.error('Error details:', error.message);
    }
    return { success: false };
  }
};

